// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u4HOUDrmp4vs61 {
  padding: var(--ds-space-100, 8px) var(--ds-space-150, 12px);
  border: none;
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-background-danger, #ffedeb);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
`, ""]);
// Exports
export var error = `u4HOUDrmp4vs61`;
export default ___CSS_LOADER_EXPORT___;
